import { Controller } from "@hotwired/stimulus";
import { createPopper } from '@popperjs/core';

export default class extends Controller {
  static targets = ["guidance", "card", "content", "loading"];
  static values = { url: String, loaded: Boolean };

  connect() {
    this._hideTimeout = null;
    this._fetching = false;
  }

  show() {
    this._cancelHide();
    this.cardTarget.classList.remove("hidden");
    createPopper(this.guidanceTarget, this.cardTarget, {
      placement: 'bottom-start',
      modifiers: [
        { name: 'offset', options: { offset: [0, 4] } },
        { name: 'preventOverflow', options: { padding: 8 } },
        { name: 'flip', options: { fallbackPlacements: ['top-start', 'bottom-end', 'top-end'] } },
      ],
    });

    if (!this.loadedValue && !this._fetching && this.hasUrlValue) {
      this._fetching = true;
      fetch(this.urlValue)
        .then((r) => r.text())
        .then((html) => {
          if (this.hasLoadingTarget) {
            this.loadingTarget.classList.add("hidden");
          }
          const fragment = document.createRange().createContextualFragment(html);
          this.contentTarget.appendChild(fragment);
          this.loadedValue = true;
        })
        .finally(() => {
          this._fetching = false;
        });
    }
  }

  hide() {
    this._scheduleHide();
  }

  _scheduleHide() {
    this._cancelHide();
    this._hideTimeout = setTimeout(() => {
      this.cardTarget.classList.add("hidden");
    }, 300);
  }

  _cancelHide() {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = null;
    }
  }

  disconnect() {
    this._cancelHide();
    if (this.hasCardTarget) {
      this.cardTarget.classList.add("hidden");
    }
  }
}
